import React, { useState, Fragment } from 'react';
import MovieCard from './MovieCard';

export default function SearchMovie(props) {
	const [ query, setQuery ] = useState('');
	const [ movies, setMovies ] = useState([]);

	const handleQueryChange = (e) => {
		setQuery(e.target.value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (query) {
			search();
			setQuery('');
		}
	};

	const filterData = (movieData) => {
		const filteredMovieData = movieData.map(({ id, title, overview, vote_average, poster_path, release_date }) => {
			return {
				id,
				title,
				overview,
				release_date,
				poster_path,
				vote_average
			};
		});
		setMovies(filteredMovieData);
	};

	async function search() {
		const url = `https://api.themoviedb.org/3/search/movie?api_key=424f14249d7ed6721e1d3fbd1d00fba2&language=en-US&page=1&query=${query}&include_adult=false`;
		try {
			const res = await fetch(url);
			const movieData = await res.json();
			const movieDetails = movieData.results;
			filterData(movieDetails);
		} catch (e) {
			console.log('Oops, there was an error! ', e);
		}
	}

	return (
		<Fragment>
			<form onSubmit={handleSubmit} className="form">
				<label htmlFor="query" />
				<input
					className="input"
					type="text"
					value={query}
					name="query"
					id="query"
					onChange={handleQueryChange}
					placeholder="search for a movie"
				/>
				<button className="button" type="submit">
					Search
				</button>
			</form>
			<div className="card-list">
				{movies.filter((movie) => movie.poster_path).map((movie) => <MovieCard key={movie.id} movie={movie} />)}
			</div>
		</Fragment>
	);
}
